// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".alert-message[data-v-172705d4]{padding:10px;background:#efd612}.alert-danger[data-v-172705d4]{background:#e0231f;color:#fff}.alert-info[data-v-172705d4]{background:#7fc0e4}", ""]);
// Exports
module.exports = exports;
